import { colors } from '../../colors';
var card = {
  textColorDark: colors.smoke,
  textColorLight: colors.white,
  bgColor: colors.darkSage,
  bgColorHero: colors.darkSage
};
export default card;